'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  font-family: ', ';\n  font-size: 1rem !important;\n  font-weight: ', ';\n  background-color: ', ' !important;\n  border-radius: 2px !important;\n  padding: 8px 12px !important;\n  opacity: 0.95 !important;\n  line-height: 18px;\n  text-align: left !important;\n  text-transform: none !important;\n\n  &.place-top {\n    &:after {\n      border-top-color: ', ' !important;\n    }\n  }\n  &.place-right {\n    &:after {\n      border-right-color: ', ' !important;\n    }\n  }\n  &.place-bottom {\n    &:after {\n      border-bottom-color: ', ' !important;\n    }\n  }\n  &.place-left {\n    &:after {\n      border-left-color: ', ' !important;\n    }\n  }\n'], ['\n  font-family: ', ';\n  font-size: 1rem !important;\n  font-weight: ', ';\n  background-color: ', ' !important;\n  border-radius: 2px !important;\n  padding: 8px 12px !important;\n  opacity: 0.95 !important;\n  line-height: 18px;\n  text-align: left !important;\n  text-transform: none !important;\n\n  &.place-top {\n    &:after {\n      border-top-color: ', ' !important;\n    }\n  }\n  &.place-right {\n    &:after {\n      border-right-color: ', ' !important;\n    }\n  }\n  &.place-bottom {\n    &:after {\n      border-bottom-color: ', ' !important;\n    }\n  }\n  &.place-left {\n    &:after {\n      border-left-color: ', ' !important;\n    }\n  }\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _TooltipBase = require('./TooltipBase');
var _TooltipBase2 = _interopRequireDefault(_TooltipBase);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/**
 * Theme Variables Used:
 *  fontFamily
 *  fontSize
 *  fontWeightRegular
 *  colorButtonPrimary
 */
var Tooltip = (0, _styledComponents2['default'])(_TooltipBase2['default'])(_templateObject, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontWeightRegular;
}, function (props) {
  return props.theme.colorButtonPrimary;
}, function (props) {
  return props.theme.colorButtonPrimary;
}, function (props) {
  return props.theme.colorButtonPrimary;
}, function (props) {
  return props.theme.colorButtonPrimary;
}, function (props) {
  return props.theme.colorButtonPrimary;
});
exports['default'] = Tooltip;